// Libellés de l'assistance : estimation (toujours calculée par le serveur), statuts des demandes.

const minutes = (m) => {
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const reste = m % 60;
  return reste ? `${h} h ${String(reste).padStart(2, "0")}` : `${h} h`;
};

export function texteEstimation(estimation) {
  if (!estimation) return "";
  if (!estimation.disponible) return "Estimation indisponible";
  if (estimation.max <= 5) return "Moins de 5 minutes";
  if (!estimation.min) return `Moins de ${minutes(estimation.max)}`;
  return `${minutes(estimation.min)} à ${minutes(estimation.max)}`;
}

export const rang = (position) => (position === 1 ? "1er" : `${position}e`);

export function resumeTicket(ticket) {
  if (!ticket) return "";
  if (ticket.statut === "en_attente") {
    const e = ticket.estimation;
    return `${rang(e?.position || 1)} · ${e?.disponible ? texteEstimation(e) : "en attente"}`;
  }
  return ticket.statut_label;
}

export const TON_TICKET = { en_attente: "amber", en_cours: "blue", terminee: "green", reattribuee: "grey" };

export const heure = (iso) => (iso ? new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }) : "");
